module.exports = __webpack_public_path__ + "static/media/c12_4.fcfe3af7.png";